import React, {Component} from 'react';
import SliderInstance from '../../blocks/slider/index';
// import ReactSlick from 'react-slick';

export default class Tutorials extends Component {

    render() {
        const sliderArray = [
            {
                desc  : {
                    text: `I can't explain how helpful Prescription Revision was! I wanted to reach out to pass on my sincere thanks to Dr Paul Ryan as his resource was integral to passing the CKT exam.`
                },
                author: {
                    name: 'Dr Zoe Lynch, UCD Scheme  '
                }
            },
            {
                desc  : {
                    text: `I found Prescription Revision to be a brilliantly focused resource for the CCT. It quickly teaches you the format of the exam and also covers very relevant topics both for the exam and everyday practice. I found it incredibly helpful and couldn't recommend it highly enough!`
                },
                author: {
                    name: 'Dr Hannah Sands, 4th year TCD Scheme'
                }
            },
            {
                desc  : {
                    text: 'Prescription Revision was super in my preparation for the CCT. I found watching videos was a nice break from reading and sometimes went for walks or to the gym listening to the cases. The cases were comprehensive yet concise and I learned lots a tips that I use in practice today. Would definitely recommend!'
                },
                author: {
                    name: 'Dr Sinead O Sullivan, 4th year TCD Scheme'
                }
            },
            {
                desc  : {
                    text: 'Naomi’s videos were of invaluable help to me in successfully passing my CCT exam. Her broad base of knowledge as well as expertise in all thing GPs were such a good resource to me while studying for this exam. Her structured approach and top tips leading into exam day were extremely useful! A resource I would use again and again.'
                },
                author: {
                    name: 'Dr Rebecca Russell, TCD Scheme'
                }
            }
        ];
        return (
            <section className="testimonials">
              <div className="section-wrap">
                <div className="container">
                  <div className="content-wrap">
                    <h1 className="section-title">
                      Testimonials
                    </h1>
                    <SliderInstance
                        collection={sliderArray}
                        type="testimonials"
                        reactSlickOptions={{
                            dots          : true,
                            fade          : false,
                            arrows        : false,
                            infinite      : false,
                            accessibility : true,
                            speed         : 1200,
                            slidesToShow  : 3,
                            slidesToScroll: 3,
                            responsive    : [{
                                breakpoint: 768,
                                settings  : {slidesToShow: 1, slidesToScroll: 1, dots: false}
                            }]
                        }}
                    />
                  </div>
                </div>
              </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/landing/components/Testimonials.js